import store from "../../../../storeSite/store.js";
import axios from "../../../axios/index.js";
import * as axiosLib from 'axios';


// Token Refresh
let isAlreadyFetchingAccessToken = false;
let subscribers = [];
//var urlBasePath = '/';
var urlBasePath = '/conta/';

function onAccessTokenFetched (access_token) {
	subscribers = subscribers.filter(callback => callback(access_token));
}

function addSubscriber (callback) {
	subscribers.push(callback);
}

export default {
	init () {
		axios.interceptors.request.use(function (config) {
			if (config &&
				config.url == '/conta/entrar' &&
				config.method == 'post' &&
				config.headers &&
				config.headers.common &&
				config.headers.common.hasOwnProperty('Authorization')
			) {
				delete config.headers.common['Authorization'];
			}
			return config;
		}, function (error) {
			return Promise.reject(error);
		});

		axios.interceptors.response.use(function (response) {
			return response;
		}, function (error) {
			if (!axiosLib.isCancel(error)) {
				console.log('axios LOGIN/LOGOUT REQUEST ERR', error);
			}
			// const { config, response: { status } } = error
			//const { config, response } = error
			//const originalRequest = config

			// if (status === 401) {
			/*if (response && response.status === 401) {
			  if (!isAlreadyFetchingAccessToken) {
				isAlreadyFetchingAccessToken = true
				store.dispatch("auth/fetchAccessToken")
				  .then((access_token) => {
					isAlreadyFetchingAccessToken = false
					onAccessTokenFetched(access_token)
				  })
			  }

			  const retryOriginalRequest = new Promise((resolve) => {
				addSubscriber(access_token => {
				  originalRequest.headers.Authorization = 'Bearer ' + access_token
				  resolve(axios(originalRequest))
				})
			  })
			  return retryOriginalRequest
			}*/
			return Promise.reject(error);
		});
	},
	login (email, pwd, rememberMe, captchaResponse) {
		return axios.post(urlBasePath + "entrar", {
			'email': email,
			'password': pwd,
			'rememberMe': rememberMe,
			"g-recaptcha-response": captchaResponse,
		});
	},
	logout () {
		return axios.post(urlBasePath + "logout", {});
	},
	refreshToken (token) {
		var data = {
			contaToken: token
		};
		return axios.post(urlBasePath + "refresh-login", data);
	}
};
